<template lang="html">
  <div
    class="error__text"
    v-if="errorText || !emptyHide"
    :class="{ check__error: checkError }"
  >
    {{ errorText || '&nbsp;' }}
  </div>
</template>

<script>
  export default {
    name: 'bimErrorField',
    props: {
      /**
       * Текст ошибки
       */
      error: {
        type: [String, Boolean],
        default: null
      },
      /**
       * рисовать пустой блок ошибки если true
       */
      emptyHide: {
        type: [String, Boolean],
        default: true
      },
      /**
       * Отступ добавляется дополнительный справа
       */
      checkError: Boolean
    },
    computed: {
      errorText () {
        if (this.error && typeof this.error !== 'boolean') {
          return this.error
        }

        return ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .error__text {
    font-size: 12px;
    color: #f74949;
    margin-top: 6px;
    margin-left: 12px;
  }
  .check__error {
    margin-left: 32px;
  }
</style>
